import { css } from 'styled-components';

export const NonSelectable = css`
  user-select: none;
  -webkit-touch-callout: none;
`;
